import Cookies from "js-cookie";

const token = "Admin-token";

export const getToken = () => {
  return Cookies.get(token);
};

export const setToken = (str: string) => {
  return Cookies.set(token, str);
};

export const removeToken = () => {
  return Cookies.remove(token);
};

export const getCookie = (key: string) => {
  return Cookies.get(key);
};

export const setCookie = (key: string, val: any) => {
  return Cookies.set(key, val);
};

export const removeCookie = (key: string) => {
  return Cookies.remove(key);
};

export const getStorage = (key: string): any => {
  return localStorage.getItem(key);
};

export const setStorage = (key: string, val: any) => {
  return localStorage.setItem(key, val);
};

export const removeStorage = (key: string) => {
  return localStorage.removeItem(key);
};

export const getSession = (key: string): any => {
  return sessionStorage.getItem(key);
};

export const setSession = (key: string, val: any) => {
  return sessionStorage.setItem(key, val);
};

export const removeSession = (key: string) => {
  return sessionStorage.removeItem(key);
};

export const handleTremble = (fn: () => void, delay: number) => {
  let time: any = null;
  return function () {
    if (time !== null) {
      clearTimeout(time);
    }
    time = setTimeout(() => {
      fn();
    }, delay);
  };
};
/**
 * @function deepClone 对象深拷贝
 */
export const deepClone = (obj: any): any => {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  let clone: any = Array.isArray(obj) ? [] : {};

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      clone[key] = deepClone(obj[key]);
    }
  }

  return clone;
};
